export const LOAD_WIDGET = 'LOAD_WIDGET';
export const LOAD_WIDGET_SUCCESS = 'LOAD_WIDGET_SUCCESS';
export const LOAD_WIDGET_FAILURE = 'LOAD_WIDGET_FAILURE';
export const EDIT_DASHBOARD = 'EDIT_DASHBOARD';
export const SAVE_WIDGET_ACTIONS = 'SAVE_WIDGET_ACTIONS';
export const SAVE_WIDGET_ACTIONS_SUCCESS = 'SAVE_WIDGET_ACTIONS_SUCCESS';
export const SAVE_WIDGET_ACTIONS_FAILURE = 'SAVE_WIDGET_ACTIONS_FAILURE';
export const SUCCESS_CHANGE_WIDGETS = 'SUCCESS_CHANGE_WIDGETS';
export const SUCCESS_DELETION = 'SUCCESS_DELETION';
export const ADD_SAMPLE_WIDGET = 'ADD_SAMPLE_WIDGET';
export const IS_CMDTY_SELECTED = 'IS_CMDTY_SELECTED';
export const HIDE_POPOUT = 'HIDE_POPOUT';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const LOAD_TEMPLIST = 'LOAD_TEMPLIST';
export const LOAD_TEMPLIST_SUCCESS= 'LOAD_TEMPLIST_SUCCESS';
export const LOAD_TEMPLIST_FAILURE = 'LOAD_TEMPLIST_FAILURE';
export const LAYOUT_CHANGE_STATUS = 'LAYOUT_CHANGE_STATUS';
export const DEFAULT_COMMODITYPAIR = 'DEFAULT_COMMODITYPAIR';
export const UPDATE_CAN_LOGOUT = 'UPDATE_CAN_LOGOUT';
export const UPDATE_TRADEBOOK_COLUMNS = 'UPDATE_TRADEBOOK_COLUMNS';
export const SAVE_SETTING='SAVE_SETTING';
export const SAVE_SETTING_SUCCESS='SAVE_SETTING_SUCCESS';
export const SAVE_SETTING_FAILURE='SAVE_SETTING_FAILURE';
export const HANDLE_SETTING_MODAL='HANDLE_SETTING_MODAL';
export const LOAD_TEMPLATE = 'LOAD_TEMPLATE';
export const HANDLE_BM_MODAL='HANDLE_BM_MODAL';
export const HANDLE_LMT_MODAL='HANDLE_LMT_MODAL';
export const CHANGE_ADDWIDGETFLAG='CHANGE_ADDWIDGETFLAG';
export const HANDLE_LAYOUT_FLAGMODAL='HANDLE_LAYOUT_FLAGMODAL';
export const LOAD_TEMP_FLAG='LOAD_TEMP_FLAG';
export const CHANGE_COMMDTY = 'CHANGE_COMMDTY';
export const ENABLE_TOOLTIP = 'ENABLE_TOOLTIP';
export const DELETE_TEMPLATE= 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_SUCCESS= 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE= 'DELETE_TEMPLATE_FAILURE';
export const CHANGE_CHART_COMMDTY= 'CHANGE_CHART_COMMDTY';
export const CHANGE_LMTORD_FLAG='CHANGE_LMTORD_FLAG';
export const CHANGE_BMKORD_FLAG='CHANGE_BMKORD_FLAG';
export const CLEAR_SAVE_TEMP_MSG='CLEAR_SAVE_TEMP_MSG';
export const LOADING_ON='LOADING_ON';
export const LOADING_OFF='LOADING_OFF';
export const IS_INITIAL_API_LOADED='IS_INITIAL_API_LOADED';
export const RESET_DASH_STATE='RESET_DASH_STATE';
export const TOGGLE_COLUMN = 'TOGGLE_COLUMN';